import {ScaleAction} from "../actions";

const Scale = (state: number = 0, action: ScaleAction) => {
    switch (action.type) {
        case "INIT_SCALE":
            return action.initialState;
        default:
            return state;
    }
};

export default Scale